<template>
  <div class="container">
    <h1>404 :(</h1>
    <p>Hmm, nic tu nie ma.</p>
    <router-link :to="{ name: returnPathName || 'index' }">Wróć...</router-link>
  </div>
</template>
<script>
export default {
  props: {
    returnPathName: String,
  },
};
</script>
